import { render, staticRenderFns } from "./StructureChart.vue?vue&type=template&id=19a4eb39&scoped=true"
import script from "./StructureChart.vue?vue&type=script&lang=js"
export * from "./StructureChart.vue?vue&type=script&lang=js"
import style0 from "./StructureChart.vue?vue&type=style&index=0&id=19a4eb39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a4eb39",
  null
  
)

export default component.exports